import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useGetTrunkTypes from './queries/useGetTrunkTypes';

import { Button, Text } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from '../../../hooks/useColumnState';

import { getTrunkTypesTableColumns } from './trunkTypesTableConfig';

export default function TrunkTypes() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const { darkMode } = useSelector((state) => state.settings);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleEditTrunkType = useCallback(
        (trunkTypeData) => {
            navigate(`/trunk-types/edit/${trunkTypeData.id}`);
        },
        [navigate],
    );

    const handleAddTrunkType = () => {
        navigate('/trunk-types/add');
    };

    const baseColumns = useMemo(
        () =>
            getTrunkTypesTableColumns({
                darkMode,
                onEditTrunkType: handleEditTrunkType,
            }),
        [darkMode, handleEditTrunkType],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetTrunkTypes(
        setTableData,
        gridRef,
        baseColumns,
    );

    const isFetchingData = isRefetching || isFetching;

    const titleName = 'Trunk Types';

    return (
        <>
            <HStack justifyContent="space-between" marginBottom={5}>
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>
                    Trunk Types
                </Text>
            </HStack>

            <AGGridMain
                gridRef={gridRef}
                tableData={tableDataWithColumns}
                isLoading={isFetchingData}
                titleName={titleName}
                refetch={refetch}
                onColumnVisible={onColumnVisible}
                extraComponents={
                    <HStack pl={5} spacing={2}>
                        <Button
                            leftIcon={<AddIcon />}
                            onClick={handleAddTrunkType}
                            size="sm"
                            padding="6px 12px">
                            Add Trunk Type
                        </Button>
                    </HStack>
                }
            />
        </>
    );
}
